import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ColumnPage from '../../../../sales-kit/components/Column/pages/List';
import { ModulePermissionProps } from '../../../../../common/module/types';

const SystemConfig = {
  filterName: 'component.filterTitle.happy-share-material-column',
  blockName: 'component.formTitle.happy-share-material-column',
  blockType: 'happyShareMaterialColumn',
  moduleType: 'HappyShare',
  addSuccessText: 'global.submit.success',
};

const HappySharePruforceColumnPage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return <ColumnPage {...props} {...SystemConfig} />;
};

export default HappySharePruforceColumnPage;
